import { TableRowCustomImpl } from './table-row-custom-impl';

// Re-export the Props type from implementation
export type { Props as TableRowCustomProps } from './table-row-custom-impl';

// ----------------------------------------------------------------------

/**
 * TableRowCustom - Orchestrator Component
 *
 * This component follows the orchestrator pattern by delegating to the implementation.
 * The actual rendering logic is in table-row-custom-impl.tsx
 *
 * Future refactoring can extract logic to use-table-row-logic.ts and
 * create a proper table-row-view.tsx with child components.
 */
export function TableRowCustom(props: any) {
  // For now, delegate directly to implementation
  // Future: const logic = useTableRowLogic(props);
  // Future: return <TableRowView {...props} {...logic} />;

  return <TableRowCustomImpl {...props} />;
}
